module.exports = __webpack_public_path__ + "img/opp-errf.a6e486e0.png";